<mat-card class="newrequest cursor" *ngIf="mandate" (click)="goItem()">
    <div class=img>
        <img [src]="mandate.photo | thumb:'400'" />
    </div>
    <div class="desc">
        <mat-card-title>{{mandate.city}} <span *ngIf="mandate.residence">- {{mandate.residence}}</span></mat-card-title>
        <!-- <mat-card-subtitle *ngIf="mandate.owners?.length">
            <ng-container *ngFor="let c of mandate.owners; let i = index">{{i > 0 ? ', ' : '' }}{{c.fullname}}
            </ng-container>
        </mat-card-subtitle> -->
        <mat-list class="h">
            <mat-list-item>
                <h3 matLine> {{this.setting.prefixMandate + mandate.ref}}</h3>
            </mat-list-item>
            <mat-list-item>
                <mat-icon *ngIf="mandate.bedrooms" matListIcon>{{GLOBAL.ICONS.BED}}</mat-icon>
                <h3 matLine>{{mandate.bedrooms}} </h3>
            </mat-list-item>
            <mat-list-item>
                <mat-icon *ngIf="mandate.bathrooms" matListIcon>{{GLOBAL.ICONS.BATH}}</mat-icon>
                <h3 matLine>{{mandate.bathrooms}} </h3>
            </mat-list-item>
            <mat-list-item>
                <ng-container *ngIf="mandate.landSurface && mandate.type !== 'land'">
                    <mat-icon matListIcon>{{GLOBAL.ICONS.SURFACE}}
                    </mat-icon>
                    <h3 matLine> {{(mandate.livingSurface ? mandate.livingSurface : mandate.builtSurface) | number}} m²
                    </h3>
                </ng-container>
            </mat-list-item>
            <mat-list-item>
                <ng-container *ngIf="mandate.landSurface && mandate.type == 'land'">
                    <mat-icon matListIcon>{{GLOBAL.ICONS.SURFACE}}</mat-icon>
                    <h3 matLine> {{mandate.landSurface | number}} {{mandate.landUnit | param:'landUnits'}} </h3>
                </ng-container>
            </mat-list-item>
        </mat-list>
        <div class="lastline">
            <div>
                <mat-icon>{{action.medium | icon:'mediums'}}</mat-icon>
                <span>{{action.originName}}</span>
            </div>
            <div class="price">
                <h4 matLine>{{mandate.priceDisplay}}</h4>
            </div>
        </div>
    </div>
</mat-card>

<mat-card class="nomandate" *ngIf="!mandate">
    <mat-list>
        <mat-list-item>
            <mat-icon *ngIf="action.medium" matListIcon>{{action.medium | icon:'mediums'}}</mat-icon>
            <h3 matLine>{{action.originName}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.mediumTerm">
            <mat-icon matListIcon color="warn">{{GLOBAL.ICONS.ALERT}}</mat-icon>
            <h3 matLine>Medium Term Rental (3 months)</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.inMauritius">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>In Mauritius</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.unitTypes?.length">
            <mat-icon matListIcon *ngFor="let unitType of action.unitTypes">
                {{unitType | icon:'unitTypes'}}
            </mat-icon>
            <h3 matLine *ngIf="action.penthouse">Penthouse</h3>
            <h3 matLine *ngIf="action.townhouse">Townhouse</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.landType">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Land Type: {{action.landType}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.landSurface">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine> {{action.landSurface | number}} {{action.landUnit | param:'landUnits'}} </h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.bedrooms">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Bedrooms: {{action.bedrooms}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.bathrooms">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Bathrooms: {{action.bathrooms}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.InteriorSurface">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Interior Surface: {{action.InteriorSurface}} m2</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.regions">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Regions: {{action.regions}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.price">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Price: {{action.price}} {{action.priceCy | param:'cies'}}</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.furnished">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Furnished</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.needRefurbishment">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>Ok to renovate if necessary</h3>
        </mat-list-item>
        <mat-list-item *ngIf="action.firstBuyer">
            <mat-icon matListIcon>{{GLOBAL.ICONS.PROJECT}}</mat-icon>
            <h3 matLine>First Buyer</h3>
        </mat-list-item>
    </mat-list>
</mat-card>

<mat-card *ngIf="action.note">
    <p>{{action.note}}</p>
</mat-card>

<div class="actionButtons" *ngIf="!action.done && project?.status !== 'new'">
    <button mat-icon-button class="active" (click)="validAction($event)">
        <mat-icon>task_alt</mat-icon>
    </button>
</div>